import { render, staticRenderFns } from "./CambiarPassword.vue?vue&type=template&id=4c65cb5e&scoped=true"
import script from "./CambiarPassword.vue?vue&type=script&lang=ts"
export * from "./CambiarPassword.vue?vue&type=script&lang=ts"
import style0 from "./CambiarPassword.vue?vue&type=style&index=0&id=4c65cb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c65cb5e",
  null
  
)

export default component.exports